import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios"; import { handleAuthError, newFormatDate } from "../../utils";
import {
    applyManageProgramFilters,
} from "../../utils/enrollmentFilters";
import { Badge, Col, Collapse, Container, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, } from "reactstrap";
import withAuth from "../withAuth";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from '../../Network';
import Moment from 'react-moment';
import moment from 'moment-timezone';
import 'moment-timezone';
import { convertSingleLessonTimes, convertSingleLessonTimesProgram } from "../../utils";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {
    BtnBold,
    BtnItalic,
    Editor,
    EditorProvider,
    Toolbar,
    BtnLink,
    BtnBulletList,
    BtnClearFormatting,
    BtnNumberedList,
    BtnStyles,
    BtnUndo,
    BtnRedo,
    BtnStrikeThrough,
    BtnUnderline
} from "react-simple-wysiwyg";
import { Copy, ExternalLink } from "lucide-react";
import { usePagination } from "../../hooks/usePagination";
import PaginationControls from "../../components/Common/PaginationControls";
import ActionsDropdown from "../../components/Common/ActionsDropdown";
import LoadingButton from "../../components/Common/LoadingButton";
import StatusBadge from "../../components/Common/StatusBadge";
import { useConfirm } from "../../contexts/ConfirmContext";
import { isMarketerReadOnly } from "../../helpers/adminRole";


const TIMES_ = [
    "12:00AM",
    "1:00AM",
    "2:00AM",
    "3:00AM",
    "4:00AM",
    "5:00AM",
    "6:00AM",
    "7:00AM",
    "8:00AM",
    "9:00AM",
    "10:00AM",
    "11:00AM",
    "12:00PM",
    "1:00PM",
    "2:00PM",
    "3:00PM",
    "4:00PM",
    "5:00PM",
    "6:00PM",
    "7:00PM",
    "8:00PM",
    "9:00PM",
    "10:00PM",
    "11:00PM",
]

const formatTime = (time) => {
    // const hour = Math.floor(time);
    // const minute = (time - hour) * 60;
    // const meridian = hour >= 12 ? "PM" : "AM";
    // const formattedHour = hour % 12 || 12; // Convert 0 to 12 for 12-hour format
    // return `${formattedHour}:${minute < 10 ? "0" : ""}${Math.floor(minute)} ${meridian}`;
    return TIMES_[time]
};

const formatTimeZone = (tz, day, time) => {
    const pTime = moment().utc(false).utcOffset(tz)
    pTime.day(day)
    pTime.hour(time)
    pTime.second(0)
    pTime.minute(0)
    return pTime
};

const FilterField = ({ label, children }) => (
    <label className="parent-filter-field">
        <span>{label}</span>
        {children}
    </label>
);

const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const formatDay = (day) => {
    // Adjust day to be within the range of 0 to 6
    //const adjustedDay = (((day - 1) % 7) + 7) % 7;
    return days[day];
};

const ManageProgram = () => {
    document.title = "Manage Program | RYD Admin";
    const { showConfirm } = useConfirm();
    const readOnly = isMarketerReadOnly();

    const [programs, setPrograms] = useState([]);
    const [programsList, setProgramsList] = useState([]);
    const [modal, setModal] = useState(false);
    const [assignModal, setAssignModal] = useState(false);
    const [assignActionModal, setAssignActionModal] = useState(false);
    const [teachers, setTeachers] = useState([]);
    const [assignableTeachers, setAssignableTeachers] = useState([]);
    const [selectedTeacher, setSelectedTeacher] = useState("");
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [loading, setLoading] = useState(true);
    const [multiIDs, setMultiIDs] = useState([]);
    const [multiTargetIDs, setMultiTargetIDs] = useState({});
    const [programMData, setProgramMData] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const [coupons, setCoupons] = useState([]);
    const [cohorts, setCohorts] = useState([]);
    const [packages, setPackages] = useState([]);
    const [filteredProgramList0, setFilteredProgramList0] = useState([]);
    const [filteredProgramList2, setFilteredProgramList2] = useState([]);
    const [displayProgramList, setDisplayProgramList] = useState([]);
    const [assignModal2, setAssignModal2] = useState(false);
    const [secondary, setSecondary] = useState(false);
    const [admins, setAdmins] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const [selectedAdminFilter, setSelectedAdminFilter] = useState('0');
    const [parentNotes, setParentNotes] = useState([]);
    const [newNote, setNewNote] = useState("");
    const [noteModal, setNoteModal] = useState(false);
    const [filterCohortId, setFilterCohortId] = useState(0);
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterPackageId, setFilterPackageId] = useState(0);
    const [filterCouponId, setFilterCouponId] = useState(0);
    const [filterTeacherAssign, setFilterTeacherAssign] = useState(0);
    const [filterTeacherId, setFilterTeacherId] = useState(0);
    const [filterPaidUnpaid, setFilterPaidUnpaid] = useState(0);
    const [filterConflictPrograms, setFilterConflictPrograms] = useState(0);
    const [filterAlertPrograms, setFilterAlertPrograms] = useState(0);
    const [filterCertificateSent, setFilterCertificateSent] = useState(0);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [actionLoading, setActionLoading] = useState(false);
    const [actionLoadingId, setActionLoadingId] = useState(null);
    const [bulkActionLoading, setBulkActionLoading] = useState(false);
    const [scheduleConflictModal, setScheduleConflictModal] = useState(false);
    const [scheduleConflicts, setScheduleConflicts] = useState([]);
    const [pendingTeacherPayload, setPendingTeacherPayload] = useState(null);

    const {
        paginatedData: paginatedPrograms,
        currentPage,
        totalPages,
        totalItems,
        pageSize,
        showAll,
        handlePageChange,
        handlePageSizeChange,
        goToNextPage,
        goToPreviousPage,
        canPreviousPage,
        canNextPage,
        paginatedDataLength,
    } = usePagination(displayProgramList, 20);

    useEffect(() => {
        fetchPrograms().then(r => null);
        fetchAdmins().then(r => null);
    }, [modal]);


    const handleAssignClick = (programData) => {
        setSelectedProgram(programData);
        setAssignModal(true)
    };

    const handleActionAssignClick = (programData) => {
        setMultiTargetIDs({})
        setAssignActionModal(true)
    };

    const handleTeacherChange = (e) => {
        setSelectedTeacher(e.target.value);
    };

    useEffect(() => {
        fetchPrograms().then(r => null)
    }, [modal]);

    useEffect(() => {
        fetchTeachers().then(r => null)
        //fetch coupon
        fetchCoupons().then(r => null)
    }, []);

    const fetchCoupons = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/coupon/all`, { params: { limit: 10000 } });
            const responseData = response.data.data;
            const data = Array.isArray(responseData) ? responseData : (responseData?.data || []);
            setCoupons(Array.isArray(data) ? data : []);
        } catch (error) {
            handleAuthError(error)
            console.error("Error:", error);
        }
    };

    const isActiveCohortProgram = (program) => program?.cohort?.isStarted === true;

    function compareFn(a, b) {
        // 1) Active cohorts first
        const aActive = isActiveCohortProgram(a) ? 0 : 1;
        const bActive = isActiveCohortProgram(b) ? 0 : 1;
        if (aActive !== bActive) return aActive - bActive;

        // 2) Then by day (Sun–Sat)
        const dayDiff = (Number(a.day) || 0) - (Number(b.day) || 0);
        if (dayDiff !== 0) return dayDiff;

        // 3) Then by WAT time (stored hour index)
        return (Number(a.time) || 0) - (Number(b.time) || 0);
    }

    const fetchAdmins = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/all`);
            setAdmins(response.data.data);
        } catch (error) {
            handleAuthError(error)
            console.error("Error fetching admins:", error);
            toast.error("Failed to fetch admins");
        }
    };

    const toggleAssignModal = (program = null) => {
        setSelectedProgram(program);
        if (!admins.length) {
            fetchAdmins();
        }
        setAssignModal2(!assignModal2);
    };

    const handleAssignParent = async () => {
        if (!selectedAdmin) {
            toast.error("Please select an admin");
            return;
        }

        try {
            const programIds = multiIDs.length > 0 ? multiIDs : [selectedProgram?.id];
            const url = secondary ? `${baseUrl}/admin/parent/program/secondary/assigned` : `${baseUrl}/admin/parent/program/assigned`
            await axios.post(url, {
                adminId: selectedAdmin,
                programIds
            });

            toast.success(`Parent(s) assigned successfully`);
            setAssignModal2(false);
            setSecondary(false)
            setSelectedAdmin(null);
            setMultiIDs([]); // Clear selection after assignment
            fetchPrograms()
        } catch (error) {
            handleAuthError(error)
            console.error("Error assigning parent:", error);
            toast.error("Failed to assign parent(s)");
        }
    };

    const toggleNoteModal = (program = null) => {
        // setParentNotes([])
        setSelectedProgram(program);
        setNoteModal(!noteModal);
    };

    const handleAlert = async () => {
        toast.warning("Processing....");
        if (!newNote.trim()) {
            toast.error("Note cannot be empty");
            return;
        }

        try {
            const programIds = multiIDs.length > 0 ? multiIDs : [selectedProgram?.id];
            const res = await axios.post(`${baseUrl}/admin/program/alert`, {
                programIds,
                note: newNote
            });
            if (res?.data?.status === false) {
                toast.error(res?.data?.message || "Failed to set alert");
                return;
            }
            toast.success("Alert set successfully");
            toggleNoteModal();
            setNewNote("");
            fetchPrograms()
            setMultiIDs([]);
        } catch (error) {
            handleAuthError(error)
            console.error("Error adding note:", error);
            toast.error("Failed to add note");
        }
    };

    const handleAlertDone = async () => {
        toast.warning("Processing....");
        try {
            const programIds = multiIDs.length > 0 ? multiIDs : [selectedProgram?.id];
            const res = await axios.post(`${baseUrl}/admin/program/alert/done`, {
                programIds
            });
            if (res?.data?.status === false) {
                toast.error(res?.data?.message || "Failed to unset alert");
                return;
            }
            toast.success("Alert Unset successfully");
            setNewNote("");
            setMultiIDs([]);
            fetchPrograms()
            setNoteModal(false);
        } catch (error) {
            handleAuthError(error)
            console.error("Error adding note:", error);
            toast.error("Failed to add note");
        }
    };

    const applyFiltersToData = (rawData, overrides = {}) => {
        if (!Array.isArray(rawData)) return { display: [], filtered0: [], filtered2: [] };
        const result = applyManageProgramFilters(rawData, {
            searchQuery: overrides.searchQuery ?? searchQuery,
            filterCohortId: overrides.filterCohortId ?? filterCohortId,
            filterStatus: overrides.filterStatus ?? filterStatus,
            filterPackageId: overrides.filterPackageId ?? filterPackageId,
            filterCouponId: overrides.filterCouponId ?? filterCouponId,
            filterTeacherAssign: overrides.filterTeacherAssign ?? filterTeacherAssign,
            filterTeacherId: overrides.filterTeacherId ?? filterTeacherId,
            filterPaidUnpaid: overrides.filterPaidUnpaid ?? filterPaidUnpaid,
            filterConflictPrograms: overrides.filterConflictPrograms ?? filterConflictPrograms,
            filterAlertPrograms: overrides.filterAlertPrograms ?? filterAlertPrograms,
            filterCertificateSent: overrides.filterCertificateSent ?? filterCertificateSent,
        });
        return {
            display: [...result.display].sort(compareFn),
            filtered0: result.filtered0,
            filtered2: result.filtered2,
        };
    };

    useEffect(() => {
        const { display, filtered0, filtered2 } = applyFiltersToData(programsList);
        setDisplayProgramList(display);
        setFilteredProgramList0(filtered0);
        setFilteredProgramList2(filtered2);
    }, [
        programsList,
        searchQuery,
        filterCohortId,
        filterStatus,
        filterPackageId,
        filterCouponId,
        filterTeacherAssign,
        filterTeacherId,
        filterPaidUnpaid,
        filterConflictPrograms,
        filterAlertPrograms,
        filterCertificateSent
    ]);

    const fetchPrograms = async (adminId = null) => {
        try {
            setLoading(true);
            const packages = await axios.get(`${baseUrl}/admin/package/all`, { params: { limit: 10000 } });
            const cohorts = await axios.get(`${baseUrl}/admin/cohort/all`, { params: { limit: 10000 } });
            
            const programParams = {};
            if (adminId && adminId !== 0) {
                programParams.adminId = adminId;
            }
            
            const response = await axios.get(`${baseUrl}/admin/program/all`, { params: programParams });
            
            const packagesData = packages.data.data;
            const packagesArray = Array.isArray(packagesData) ? packagesData : (packagesData?.data || []);
            const cohortsData = cohorts.data.data;
            const cohortsArray = Array.isArray(cohortsData) ? cohortsData : (cohortsData?.data || []);
            
            setPrograms(response?.data?.data);
            setCohorts(Array.isArray(cohortsArray) ? cohortsArray : []);
            setPackages(Array.isArray(packagesArray) ? packagesArray : []);
            setLoading(false);
            
            setTimeout(() => {
                const responseData = response?.data?.data;
                const xdata = Array.isArray(responseData) ? responseData : (responseData?.data || []);
                const __xdata = Array.isArray(xdata) ? xdata.sort(compareFn) : [];
                setProgramsList(__xdata);
                const { display, filtered0, filtered2 } = applyFiltersToData(__xdata);
                setDisplayProgramList(display);
                setFilteredProgramList0(filtered0);
                setFilteredProgramList2(filtered2);
                setLoading(false);
            }, 100);
        } catch (error) {
            handleAuthError(error);
            setLoading(false);
            console.error("Error fetching programs:", error);
            toast.error("Failed to fetch programs");
        }
    };

    const fetchTeachers = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/teacher/all`);
            setTeachers(response.data.data);
            // Assign dropdowns only offer active teachers; filters above keep the full list.
            // If this endpoint fails (e.g. API not updated yet), use the full list minus deactivated teachers.
            const assignableRes = await axios.get(`${baseUrl}/admin/teacher/assignable`).catch(() => null);
            setAssignableTeachers(Array.isArray(assignableRes?.data?.data)
                ? assignableRes.data.data
                : (Array.isArray(response.data.data) ? response.data.data : []).filter((teacher) => teacher?.status !== false));
        } catch (error) {
            handleAuthError(error)
            console.error("Error:", error);
        }
    };

    const confirmScheduleConflictAndAssign = async () => {
        if (!pendingTeacherPayload) return;
        const { programIds, teacherId, isBatch } = pendingTeacherPayload;
        try {
            setLoading(true);
            if (isBatch) {
                await axios.post(`${baseUrl}/admin/program/batch-update`, {
                    ids: programIds,
                    ...multiTargetIDs,
                    acknowledgeScheduleConflict: true
                });
                toast.success("Program data altered changes");
                setAssignActionModal(false);
            } else {
                await axios.post(`${baseUrl}/admin/program/assign/teacher`, {
                    programIds,
                    teacherId,
                    acknowledgeScheduleConflict: true
                });
                toast.success("Teacher assigned successfully.");
                setAssignModal(false);
            }
            setScheduleConflictModal(false);
            setPendingTeacherPayload(null);
            setScheduleConflicts([]);
            await fetchPrograms();
        } catch (error) {
            handleAuthError(error);
            toast.error(isBatch ? "Batch update failed" : "Failed to assign teacher.");
        } finally {
            setLoading(false);
        }
    };

    const handleTeacherAssignClick = async () => {
        if (!selectedTeacher || selectedTeacher === "") {
            toast.warn("Select a teacher first.");
            return;
        }
        try {
            setLoading(true);
            const checkRes = await axios.post(`${baseUrl}/admin/program/check-teacher-schedule-conflicts`, {
                teacherId: Number(selectedTeacher),
                programIds: selectedProgram.id
            });
            const payload = checkRes.data?.data;
            if (payload?.hasConflict && payload?.conflicts?.length) {
                setScheduleConflicts(payload.conflicts);
                setPendingTeacherPayload({
                    programIds: selectedProgram.id,
                    teacherId: Number(selectedTeacher),
                    isBatch: false
                });
                setScheduleConflictModal(true);
                setLoading(false);
                return;
            }
            await axios.post(`${baseUrl}/admin/program/assign/teacher`, {
                programIds: selectedProgram.id,
                teacherId: selectedTeacher
            });
            await fetchPrograms();
            toast.success("Teacher assigned successfully.");
            setAssignModal(false);
            setLoading(false);
        } catch (error) {
            if (error.response?.status === 409 && error.response?.data?.data?.conflicts) {
                setScheduleConflicts(error.response.data.data.conflicts);
                setPendingTeacherPayload({
                    programIds: selectedProgram.id,
                    teacherId: Number(selectedTeacher),
                    isBatch: false
                });
                setScheduleConflictModal(true);
            } else {
                handleAuthError(error);
                toast.error("Failed to assign teacher.");
            }
            setLoading(false);
        }
    };

    const handleProgramClickSubmit = async () => {
        if (!selectedProgram || !selectedProgram?.id) {
            //console.error("Invalid program data.");
            toast.warn("Reload this page and try again")
            return;
        }
        //if nothing was picked
        if (Object.keys(programMData).length < 1) {
            toast.dark("No changes were made...")
            return;
        }
        //check and push to server
        await axios.put(`${baseUrl}/admin/program/edit/${selectedProgram.id}`, programMData);
        toast.success("Program data altered changes");
        await fetchPrograms()
    }

    const handleToggleIsPaid = async (programData) => {
        try {
            if (!programData || !programData.id) {
                //console.error("Invalid program data.");
                return;
            }
            const confirmed = await showConfirm({
                title: "Toggle payment status",
                message: "Are you sure you want to toggle this program payment status?",
                variant: "primary",
            });
            if (!confirmed) return;
            const updatedProgram = { ...programData, isPaid: !programData.isPaid };
            await axios.put(
                `${baseUrl}/admin/program/edit/${programData.id}`,
                updatedProgram
            );
            const updatedPrograms = programs.map((program) =>
                program.id === programData.id ? updatedProgram : program
            );
            setPrograms(updatedPrograms);
            toast.success("Program marked as paid.");
            await fetchPrograms();
        } catch (error) {
            handleAuthError(error)
            console.error("Error:", error);
        }
    };

    const handleProgramClick = (programData) => {
        // Pass program data to toggle for editing
        setSelectedProgram(programData)
        setModal(true)
    };

    const processBatchOperations = async () => {
        try {
            if (multiIDs.length > 0 && Object.keys(multiTargetIDs).length > 0) {
                if (multiTargetIDs.teacherId) {
                    const checkRes = await axios.post(`${baseUrl}/admin/program/check-teacher-schedule-conflicts`, {
                        teacherId: Number(multiTargetIDs.teacherId),
                        programIds: multiIDs
                    });
                    const payload = checkRes.data?.data;
                    if (payload?.hasConflict && payload?.conflicts?.length) {
                        setScheduleConflicts(payload.conflicts);
                        setPendingTeacherPayload({
                            programIds: multiIDs,
                            teacherId: Number(multiTargetIDs.teacherId),
                            isBatch: true
                        });
                        setScheduleConflictModal(true);
                        return;
                    }
                }
                await axios.post(`${baseUrl}/admin/program/batch-update`, { ids: multiIDs, ...multiTargetIDs });
                toast.success("Program data altered changes");
                await fetchPrograms();
            } else {
                toast.error("Please, select at least 1 child/program to perform action");
            }
        } catch (e) {
            if (e.response?.status === 409 && e.response?.data?.data?.conflicts) {
                setScheduleConflicts(e.response.data.data.conflicts);
                setPendingTeacherPayload({
                    programIds: multiIDs,
                    teacherId: multiTargetIDs.teacherId ? Number(multiTargetIDs.teacherId) : null,
                    isBatch: true
                });
                setScheduleConflictModal(true);
            } else {
                handleAuthError(e);
                toast.error("Reload this page and try again");
            }
        }
    };

    const processCertificate = async () => {
        //performing group actions
        try {
            if (multiIDs.length > 0) {
                const response = await axios.post(`${baseUrl}/admin/parent/certificate`, { id: multiIDs });
                if (!response.data.status) {
                    toast.error(response.data.message);
                } else {
                    toast.success("Certificate downloader email  sent successfully");
                    // await fetchPrograms()
                }

            } else {
                toast.error("Please, select at least 1 child/program to perform action")
            }
        } catch (e) {
            handleAuthError(e)
            toast.error("Reload this page and try again")
        }
    }

    const processSingleCertificate = async (data) => {
        //performing group actions
        try {
            if (data.isCompleted === true) {
                const response = await axios.post(`${baseUrl}/admin/parent/single/certificate`, { id: data.id });
                if (!response.data.status) {
                    toast.error(response.data.message);
                } else {
                    toast.success("Certificate downloader email  sent successfully");
                    // await fetchPrograms()
                }

            } else {
                toast.error("Error sending certificate, this program is not completed")
            }
        } catch (e) {
            handleAuthError(e)
            toast.error("Reload this page and try again")
        }
    }

    const getStatusColor = (status) => {
        return status === 1 ? 'green' : 'gray';
    };

    const exportToExcel = () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';

        const dataToExport = displayProgramList.map(program => ({
            'Parent Name': `${program?.child?.parent?.firstName} ${program?.child?.parent?.lastName}`,
            'Child Name': `${program?.child?.firstName} ${program?.child?.lastName}`,
            'Country': program?.child?.parent?.country,
            'Phone': program?.child?.parent?.phone,
            'Email': program?.child?.parent?.email,
            'Age': program?.child?.age,
            'Gender': program?.child?.gender,
            'Teacher': program?.teacher?.firstName,
            'Package': program?.package?.title,
            'Cohort': program?.cohort?.title || "No Cohort",
            'Level': program?.package?.level,
            'Time': formatTime(program.time),
            'Local Time': convertSingleLessonTimesProgram(formatTime(program.time), program?.child?.parent?.timezone, formatDay(program.day)),
            'Day': formatDay(program.day),
            'Curriculum': program?.child?.curriculum === 1 ? 'New' : 'Old',
            'Certificate Sent': program?.certificateSent ? 'Yes' : 'No',
            'Child completed cohort (teacher)': program?.teacherCohortCompleted === true ? 'Yes' : program?.teacherCohortCompleted === false ? 'No' : '',
            'Status': program.isPaid ? 'Paid' : 'Unpaid',
            'Coupon': program?.coupon?.code || '',
            'Date Created': moment(program?.createdAt).format('DD-MM-YY')
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, `programs_export_${new Date().getTime()}` + fileExtension);
    };

    const handleComplete = async (id, status) => {
        //check and push to server
        await axios.put(`${baseUrl}/admin/complete/single/program/status/${id}`, { status });
        toast.success("Program updated successfully");
        await fetchPrograms()
    }

    const handleBulkComplete = async () => {
        //check and push to server
        await axios.post(`${baseUrl}/admin/complete/program/status`, { ids: multiIDs, status: true });
        toast.success("Program completed successfully");
        await fetchPrograms()
    }

    const handleBulkUncomplete = async () => {
        await axios.post(`${baseUrl}/admin/complete/program/status`, { ids: multiIDs, status: false });
        toast.success("Program(s) marked as not completed");
        await fetchPrograms()
    }

    const handleSelectAllChange = (e) => {
        if (e.target.checked) {
            // Select all items
            const allIDs = displayProgramList.map(program => program.id);
            setMultiIDs(allIDs);
            toast.warn("All items have been added to the action list.");
        } else {
            setMultiIDs([])
            toast.error("All items have been removed from the action list.");
        }
    };

    const getDndValue = (status) => {
        if (status === 0) {
            return 'OFF';
        } else {
            return 'ON';
        }
    };

    const getStatusColorr = (status) => {
        switch (status) {
            case 0:
                return 'danger';
            case 1:
                return 'success';
        }
    };

    const toggleDnd = async (parentId) => {
        try {
            const response = await axios.get(`${baseUrl}/admin/parent/dnd/${parentId}`);
            const updatedParents = response.data.data;
            toast.success("DND activated successfully");
            fetchPrograms()
        } catch (error) {
            handleAuthError(error)
            console.error("Error:", error);
            toast.error("Failed to update status");
        }
    };

    function openProjectUrl(rawUrl) {
        if (!rawUrl) return;

        let finalUrl = rawUrl.trim();

        if (/^https?:\/\//i.test(finalUrl)) {
            window.open(finalUrl, "_blank");
        } else {
            finalUrl = `https://${finalUrl.replace(/^\/+/, "")}`;
            window.open(finalUrl, "_blank");
        }
    }

    return (
        <React.Fragment>
            <ToastContainer />
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Dashboard" breadcrumbItem={`Manage Program (${displayProgramList.length})`} />
                    {readOnly && (
                        <Row className="mb-2">
                            <Col>
                                <div className="alert alert-secondary mb-3 py-2">
                                    Read-only view — search and filters only; actions are disabled.
                                </div>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col lg="12">
                            <Col md={12}>
                                <div className="parent-filter-panel mb-3">
                                    <div className="parent-filter-toolbar">
                                        <div className="parent-filter-search">
                                            <i className="mdi mdi-magnify" />
                                            <Input
                                                type="text"
                                                placeholder="Search name..."
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                        </div>
                                        <div className="parent-filter-actions">
                                            <div className="parent-filter-actions-main">
                                            <button
                                                type="button"
                                                className={`btn btn-light ${filtersOpen ? "active" : ""}`}
                                                onClick={() => setFiltersOpen((open) => !open)}
                                            >
                                                <i className={`mdi mdi-chevron-${filtersOpen ? "up" : "down"}`}></i>
                                                Filters
                                            </button>
                                            <LoadingButton
                                                color="light"
                                                loading={actionLoading}
                                                onClick={async () => {
                                                    setActionLoading(true);
                                                    setSearchQuery("");
                                                    setSelectedAdminFilter("0");
                                                    setFilterCohortId(0);
                                                    setFilterStatus(0);
                                                    setFilterPackageId(0);
                                                    setFilterCouponId(0);
                                                    setFilterTeacherAssign(0);
                                                    setFilterTeacherId(0);
                                                    setFilterPaidUnpaid(0);
                                                    setFilterConflictPrograms(0);
                                                    setFilterAlertPrograms(0);
                                                    setFilterCertificateSent(0);
                                                    try {
                                                        await fetchPrograms();
                                                    } finally {
                                                        setActionLoading(false);
                                                    }
                                                }}
                                            >
                                                <i className="mdi mdi-filter-remove-outline"></i> Clear
                                            </LoadingButton>
                                            </div>
                                            {!readOnly && (
                                                <div className="parent-filter-actions-extra">
                                                    <button type="button" className="btn btn-light" onClick={() => toggleAssignModal()} disabled={multiIDs.length === 0}>
                                                        <i className="mdi mdi-account-plus"></i> Assign
                                                    </button>
                                                    <button type="button" className="btn btn-light" onClick={() => toggleNoteModal()} disabled={multiIDs.length === 0}>
                                                        <i className="mdi mdi-bell"></i> Set Alert
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-light"
                                                        onClick={() => {
                                                            showConfirm({ title: "Unset alert", message: `Are you sure you want to unset the alert for ${multiIDs.length} program(s)?`, variant: "primary" }).then(async (ok) => { if (ok) { setBulkActionLoading(true); try { await handleAlertDone(); } finally { setBulkActionLoading(false); } } });
                                                        }}
                                                        disabled={multiIDs.length === 0 || bulkActionLoading}
                                                    >
                                                        <i className="mdi mdi-bell-cancel"></i> Unset Alert
                                                    </button>
                                                    <div className="d-flex align-items-center gap-2">
                                                        {bulkActionLoading && (
                                                            <span className="d-flex align-items-center text-muted small me-1">
                                                                <span className="spinner-border spinner-border-sm me-1" role="status" />
                                                                Processing...
                                                            </span>
                                                        )}
                                                        <button
                                                            onClick={() => {
                                                                showConfirm({ title: "Send certificate email", message: `You're about to send a certificate downloader email to ${multiIDs.length} parent(s). Do you want to proceed?`, variant: "primary" }).then(async (ok) => { if (ok) { setBulkActionLoading(true); try { await processCertificate(); } finally { setBulkActionLoading(false); } } });
                                                            }}
                                                            title="Send certificate email to parents"
                                                            disabled={bulkActionLoading}
                                                        >
                                                            <i className="mdi mdi-mail font-size-20"></i>
                                                        </button>
                                                        <button onClick={handleActionAssignClick} title="Teacher Assignment" disabled={bulkActionLoading}>
                                                            <i className="mdi mdi-clipboard-account font-size-20"></i>
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                showConfirm({ title: "Export data", message: "You're about to export the programs data. Do you want to proceed?", variant: "primary" }).then(async (ok) => { if (ok) { setBulkActionLoading(true); try { exportToExcel(); } finally { setBulkActionLoading(false); } } });
                                                            }}
                                                            title="Export to Excel"
                                                            disabled={bulkActionLoading}
                                                        >
                                                            <i className="mdi mdi-file-excel font-size-20"></i>
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                showConfirm({ title: "Complete programs", message: `You're about to complete ${multiIDs.length} program(s). Do you want to proceed?`, variant: "danger" }).then(async (ok) => { if (ok) { setBulkActionLoading(true); try { await handleBulkComplete(); } finally { setBulkActionLoading(false); } } });
                                                            }}
                                                            title="Complete Programs"
                                                            disabled={multiIDs.length === 0 || bulkActionLoading}
                                                        >
                                                            <i className="mdi mdi-check font-size-20"></i>
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                showConfirm({ title: "Uncomplete programs", message: `You're about to mark ${multiIDs.length} program(s) as not completed. Do you want to proceed?`, variant: "danger" }).then(async (ok) => { if (ok) { setBulkActionLoading(true); try { await handleBulkUncomplete(); } finally { setBulkActionLoading(false); } } });
                                                            }}
                                                            title="Mark selected programs as not completed"
                                                            disabled={multiIDs.length === 0 || bulkActionLoading}
                                                        >
                                                            <i className="mdi mdi-undo-variant font-size-20"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <Collapse isOpen={filtersOpen}>
                                        <div className="parent-filter-groups">
                                            <section className="parent-filter-group parent-filter-group-wide">
                                                <h6>Program</h6>
                                                <div className="parent-filter-grid">
                                                    <FilterField label="Cohort">
                                                        <select className="form-control" value={filterCohortId} onChange={(e) => setFilterCohortId(Number(e.target.value))}>
                                                            <option value={0}>All</option>
                                                            {cohorts && cohorts.map((d) => (
                                                                <option key={d.id} value={d.id}>{d.title}</option>
                                                            ))}
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="Status">
                                                        <select className="form-control" value={filterStatus} onChange={(e) => setFilterStatus(Number(e.target.value))}>
                                                            <option value={0}>All</option>
                                                            <option value={1}>Active enrolment</option>
                                                            <option value={2}>Awaiting checkout</option>
                                                            <option value={3}>Paid with promo</option>
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="Payment">
                                                        <select className="form-control" value={filterPaidUnpaid} onChange={(e) => setFilterPaidUnpaid(Number(e.target.value))}>
                                                            <option value={0}>All</option>
                                                            <option value={1}>Paid</option>
                                                            <option value={2}>Unpaid</option>
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="Package">
                                                        <select className="form-control" value={filterPackageId} onChange={(e) => setFilterPackageId(Number(e.target.value))}>
                                                            <option value={0}>All</option>
                                                            {packages.map((p) => (
                                                                <option key={p.id} value={p.id}>{p.title}</option>
                                                            ))}
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="Coupon">
                                                        <select className="form-control" value={filterCouponId} onChange={(e) => setFilterCouponId(Number(e.target.value))}>
                                                            <option value={0}>All</option>
                                                            {Array.isArray(coupons) && coupons.map((c) => (
                                                                <option key={c.id} value={c.id}>{c.code} [{c.value}]</option>
                                                            ))}
                                                        </select>
                                                    </FilterField>
                                                </div>
                                            </section>
                                            <section className="parent-filter-group">
                                                <h6>People</h6>
                                                <div className="parent-filter-grid">
                                                    <FilterField label="Assigned admin">
                                                        <select
                                                            className="form-control"
                                                            value={selectedAdminFilter}
                                                            onChange={async (e) => {
                                                                const value = e.target.value;
                                                                setSelectedAdminFilter(value);
                                                                setSearchQuery("");
                                                                setFilterCohortId(0);
                                                                setFilterStatus(0);
                                                                setFilterPackageId(0);
                                                                setFilterCouponId(0);
                                                                setFilterTeacherAssign(0);
                                                                setFilterTeacherId(0);
                                                                setFilterPaidUnpaid(0);
                                                                setFilterConflictPrograms(0);
                                                                setFilterAlertPrograms(0);
                                                                setFilterCertificateSent(0);
                                                                if (value === "0" || value === 0) {
                                                                    await fetchPrograms();
                                                                } else if (value === "unassigned") {
                                                                    await fetchPrograms("unassigned");
                                                                } else {
                                                                    await fetchPrograms(Number(value));
                                                                }
                                                            }}
                                                        >
                                                            <option value={0}>All</option>
                                                            <option value="unassigned">Unassigned</option>
                                                            {admins?.length > 0 && admins.map((admin) => (
                                                                <option key={admin?.id} value={admin?.id}>{admin.fullName}</option>
                                                            ))}
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="Teacher assignment">
                                                        <select className="form-control" value={filterTeacherAssign} onChange={(e) => setFilterTeacherAssign(Number(e.target.value))}>
                                                            <option value={0}>All</option>
                                                            <option value={1}>With teacher</option>
                                                            <option value={2}>No teacher</option>
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="Teacher">
                                                        <select className="form-control" value={filterTeacherId} onChange={(e) => setFilterTeacherId(Number(e.target.value))}>
                                                            <option value={0}>All</option>
                                                            {teachers?.length > 0 && teachers.map((teacher) => (
                                                                <option key={teacher?.id} value={teacher?.id}>{teacher.firstName} {teacher.lastName}</option>
                                                            ))}
                                                        </select>
                                                    </FilterField>
                                                </div>
                                            </section>
                                            <section className="parent-filter-group">
                                                <h6>Flags</h6>
                                                <div className="parent-filter-grid">
                                                    <FilterField label="Schedule conflict">
                                                        <select className="form-control" value={filterConflictPrograms} onChange={(e) => setFilterConflictPrograms(Number(e.target.value))}>
                                                            <option value={0}>All</option>
                                                            <option value={1}>With conflict</option>
                                                            <option value={2}>No conflict</option>
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="Alert">
                                                        <select className="form-control" value={filterAlertPrograms} onChange={(e) => setFilterAlertPrograms(Number(e.target.value))}>
                                                            <option value={0}>All</option>
                                                            <option value={1}>With alert</option>
                                                            <option value={2}>No alert</option>
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="Certificate sent">
                                                        <select className="form-control" value={filterCertificateSent} onChange={(e) => setFilterCertificateSent(Number(e.target.value))}>
                                                            <option value={0}>All</option>
                                                            <option value={1}>Yes</option>
                                                            <option value={2}>No</option>
                                                        </select>
                                                    </FilterField>
                                                </div>
                                            </section>
                                        </div>
                                    </Collapse>
                                </div>
                            </Col>
                            {/* </Row> */}
                            <Row>
                                <Col xl="12">
                                    {loading ? (
                                        <div className="text-center mt-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : displayProgramList.length === 0 ? (
                                        <div className="text-center mt-5">
                                            <h3>No data available</h3>
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                        <table className="table align-middle table-hover">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {readOnly ? (
                                                            <span className="text-muted">#</span>
                                                        ) : (
                                                        <div style={{ width: 50 }} className={'align-middle'}>
                                                            <input
                                                                style={{ marginRight: 5 }}
                                                                type={'checkbox'}
                                                                onChange={e => handleSelectAllChange(e)}
                                                            />
                                                            All
                                                        </div>
                                                        )}
                                                    </th>
                                                    <th>P.Name</th>
                                                    <th>P.Assigned.To</th>
                                                    <th>C.Name</th>
                                                    <th>Phone</th>
                                                    <th>Email</th>
                                                    <th>Alert</th>
                                                    <th>Slot conflict</th>
                                                    <th>Age</th>
                                                    <th>Gender</th>
                                                    <th>T.Name</th>
                                                    <th>P.Title</th>
                                                    <th>Level</th>
                                                    <th>Time</th>
                                                    <th>(WAT)</th>
                                                    <th>Day</th>
                                                    <th>Project</th>
                                                    <th>Curriculum</th>
                                                    <th>Completed</th>
                                                    <th>Child completed cohort (teacher)</th>
                                                    <th>Certificate sent</th>
                                                    <th>DND</th>
                                                    <th>Status</th>
                                                    {!readOnly && <th></th>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paginatedPrograms.map((program, index) => {
                                                    const globalIndex = showAll 
                                                        ? index 
                                                        : (currentPage - 1) * pageSize + index;
                                                    return (
                                                        <tr key={program.id || index}
                                                            style={{
                                                                backgroundColor: (program.isPaid) ? '#f1fdf4' : '#fff',
                                                                border: program.alertNote ? "2px solid red" : program.teacherScheduleConflict ? "2px solid #fd7e14" : ""
                                                            }}>
                                                            <td>
                                                                <div style={{ width: 50 }} className={'align-middle'}>
                                                                    {!readOnly && (
                                                                    <input style={{ marginRight: 5 }} type={'checkbox'} checked={multiIDs.includes(program.id)}
                                                                        onClick={(d) => {
                                                                            //multiple selection push to array
                                                                            if (multiIDs.includes(program.id)) {
                                                                                //remove from array
                                                                                setMultiIDs(multiIDs.filter(i => i !== program.id))
                                                                                toast.error(program?.child?.firstName + " removed is been from the action list.")
                                                                            } else {
                                                                                setMultiIDs([...multiIDs, program.id])
                                                                                toast.warn(program?.child?.firstName + " has been added to action list.")
                                                                            }
                                                                        }} />
                                                                    )}
                                                                    {globalIndex + 1}
                                                                </div>
                                                            </td>
                                                        <td>{program?.child?.parent?.firstName + " " + program?.child?.parent?.lastName}</td>
                                                        <td>{program?.child?.parent?.assignedTo ? program?.child?.parent?.admin?.fullName : "Unassigned"}</td>
                                                        <td>{program?.child?.firstName + " " + program?.child?.lastName}
                                                            <br />
                                                            [{program?.child?.parent?.country}]
                                                        </td>
                                                        <td>{program?.child?.parent?.phone}</td>
                                                        <td>{program?.child?.parent?.email}</td>
                                                        <td>{program?.alertNote ? <span className={'blink text-danger'} ><b>ALERT</b></span> : "-----"}</td>
                                                        <td>{program?.teacherScheduleConflict ? (
                                                            <span className="blink text-warning"><Badge color="warning" className="text-dark">CONFLICT</Badge></span>
                                                        ) : "—"}</td>
                                                        <td>{program?.child?.age}</td>
                                                        <td>{program?.child?.gender}</td>
                                                        <td>{program?.teacher?.firstName}</td>
                                                        <td>{program?.package?.title}<br /><small
                                                            style={{ color: 'red' }}>[{program?.cohort?.title || "No Cohort"}]</small>
                                                        </td>
                                                        {/*<td>*/}
                                                        {/*  {program?.package?.status ? "Active" : "Inactive"}*/}
                                                        {/*</td>*/}
                                                        <td>{program?.package?.level}</td>
                                                        <td>{formatTime(program.time)}</td>
                                                        <td>{convertSingleLessonTimesProgram(formatTime(program.time), program?.child?.parent?.timezone, formatDay(program.day))}</td>
                                                        <td>{formatDay(program.day)}</td>
                                                        <td>
                                                            {program?.projectUrl ? (
                                                                <>
                                                                    <StatusBadge variant="success">Done</StatusBadge>
                                                                    <span
                                                                        onClick={() => {
                                                                            navigator.clipboard.writeText(program?.projectUrl);
                                                                            toast.success("Copied successfully");
                                                                        }}
                                                                        className="p-1 hover:bg-gray-100 rounded cursor-pointer"
                                                                        title="Copy URL"
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <Copy size={15} />
                                                                    </span>
                                                                    <span
                                                                        onClick={() => openProjectUrl(program?.projectUrl)}
                                                                        className="p-1 hover:bg-gray-100 rounded cursor-pointer ml-1"
                                                                        title="Open in new tab"
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <ExternalLink size={15} />
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <StatusBadge variant="warning">Not yet</StatusBadge>
                                                            )}
                                                        </td>
                                                        <td> <span style={{ color: getStatusColor(program?.child?.curriculum) }}>
                                                            {program?.child?.curriculum === 1 ? 'New' : 'Old'}
                                                        </span>
                                                        </td>
                                                        <td>
                                                            <StatusBadge variant={program?.isCompleted === true ? "success" : "danger"}>
                                                                {program?.isCompleted === true ? "Yes" : "No"}
                                                            </StatusBadge>
                                                        </td>
                                                        <td>
                                                            {program?.teacherCohortCompleted === true ? (
                                                                <StatusBadge variant="success">Yes</StatusBadge>
                                                            ) : program?.teacherCohortCompleted === false ? (
                                                                <StatusBadge variant="danger">No</StatusBadge>
                                                            ) : (
                                                                <span className="text-muted" title="No teacher report yet">—</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <StatusBadge variant={program?.certificateSent === true ? "success" : "danger"}>
                                                                {program?.certificateSent === true ? "Yes" : "No"}
                                                            </StatusBadge>
                                                        </td>
                                                        <td>
                                                            <StatusBadge variant={getStatusColorr(program?.child?.parent?.dnd)}>
                                                                {getDndValue(program?.child?.parent?.dnd)}
                                                            </StatusBadge>
                                                        </td>
                                                        <td>
                                                            <div style={{ width: 50 }}>
                                                                {readOnly ? (
                                                                    <>
                                                                        <span>{program.isPaid ? `Paid${program.paidWithPromo ? " (promo)" : ""}` : "Unpaid"}</span>
                                                                        <br />
                                                                        <small style={{ fontSize: 10, backgroundColor: "#e3e3e3", padding: 2, display: program?.coupon?.code ? "block" : "none" }}>{program?.coupon?.code}</small>
                                                                        <small style={{ fontSize: 10 }}><Moment format={'DD-MM-YY'} date={program?.createdAt} /></small>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                {program.isPaid ? (
                                                                    <a rel={'noreferrer'}
                                                                        href={'#' + program.trxId}
                                                                        onClick={(e) => {
                                                                            e.preventDefault()
                                                                            handleToggleIsPaid(program).then(r => null)
                                                                        }}
                                                                    >Paid {program.paidWithPromo ? (<i className="mdi mdi-ticket font-size-15"></i>) : ""}</a>
                                                                ) : (
                                                                    <a rel={'noreferrer'} href={'#'} onClick={(e) => {
                                                                        e.preventDefault()
                                                                        handleToggleIsPaid(program).then(r => null)
                                                                    }}
                                                                        disabled={program.isPaid}>
                                                                        Unpaid
                                                                    </a>
                                                                )}
                                                                {!program.isPaid && (
                                                                    <Link
                                                                        className="ms-1 text-primary"
                                                                        to="#"
                                                                        onClick={(e) => e.preventDefault()}
                                                                    ></Link>
                                                                )}
                                                                <br />
                                                                <small style={{ fontSize: 10, backgroundColor: "#e3e3e3", padding: 2, display: program?.coupon?.code ? "block" : "none" }}>{program?.coupon?.code}</small>
                                                                <small style={{ fontSize: 10 }}><Moment format={'DD-MM-YY'} date={program?.createdAt} /></small>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </td>
                                                        {!readOnly && (
                                                        <td className="">
                                                            <ActionsDropdown
                                                                loading={actionLoadingId === program.id}
                                                                toggleTitle="Program actions"
                                                                items={[
                                                                    { label: "Update package info", icon: "mdi-clock-outline", onClick: () => handleProgramClick(program), variant: "danger" },
                                                                    { label: "Send certificate", icon: "mdi-mail", onClick: () => showConfirm({ title: "Send certificate", message: `You're about to send a certificate downloader email to ${program?.child?.parent?.firstName || ""} ${program?.child?.parent?.lastName || ""}. Do you want to proceed?`, variant: "primary" }).then(async (ok) => { if (ok) { setActionLoadingId(program.id); try { await processSingleCertificate(program); } finally { setActionLoadingId(null); } } }), variant: "success" },
                                                                    { label: "Manage teacher", icon: "mdi-clipboard-account", onClick: () => handleAssignClick(program), variant: "primary" },
                                                                    { divider: true },
                                                                    program?.isCompleted
                                                                        ? { label: "Uncomplete program", icon: "mdi-cancel", onClick: () => showConfirm({ title: "Uncomplete program", message: "You're about to uncomplete this program. Do you want to proceed?", variant: "primary" }).then(async (ok) => { if (ok) { setActionLoadingId(program.id); try { await handleComplete(program.id, false); } finally { setActionLoadingId(null); } } }), variant: "primary" }
                                                                        : { label: "Complete program", icon: "mdi-check", onClick: () => showConfirm({ title: "Complete program", message: "You're about to complete this program. Do you want to proceed?", variant: "primary" }).then(async (ok) => { if (ok) { setActionLoadingId(program.id); try { await handleComplete(program.id, true); } finally { setActionLoadingId(null); } } }), variant: "primary" },
                                                                    { divider: true },
                                                                    { label: "Assign to admin", icon: "mdi-account-arrow-right", onClick: () => toggleAssignModal(program), variant: "warning" },
                                                                    { label: "Alert admin", icon: "mdi-bell", onClick: () => toggleNoteModal(program), variant: "warning" },
                                                                    { label: `Toggle DND (${getDndValue(program?.child?.parent?.dnd)})`, icon: "mdi-do-not-disturb", onClick: () => { const isOn = program?.child?.parent?.dnd === 1; showConfirm({ title: "Toggle DND", message: isOn ? "Turn DND OFF for this parent?" : "Turn DND ON for this parent?", variant: "primary" }).then(async (ok) => { if (ok) { setActionLoadingId(program.id); try { await toggleDnd(program?.child?.parent?.id); } finally { setActionLoadingId(null); } } }); }, variant: "info" },
                                                                ]}
                                                            />
                                                        </td>
                                                        )}
                                                    </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                        </div>
                                    )}
                                    {displayProgramList.length > 0 && (
                                        <PaginationControls
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            totalItems={totalItems}
                                            pageSize={pageSize}
                                            showAll={showAll}
                                            handlePageChange={handlePageChange}
                                            handlePageSizeChange={handlePageSizeChange}
                                            goToNextPage={goToNextPage}
                                            goToPreviousPage={goToPreviousPage}
                                            canPreviousPage={canPreviousPage}
                                            canNextPage={canNextPage}
                                            paginatedDataLength={paginatedDataLength}
                                        />
                                    )}
                                    <Modal isOpen={modal} toggle={() => setModal(!modal)}>
                                        <ModalHeader toggle={() => setModal(!modal)}>
                                            {"Modify Program Data"}
                                        </ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <small className={'mb-2 text-danger'}>Warning: Check and be sure of
                                                    parent timezone offset before any changes</small>
                                                <Col xs={12}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <Label>Cohort</Label>
                                                                <select className={'form-control'}
                                                                    onChange={e => setProgramMData({
                                                                        ...programMData,
                                                                        cohortId: e.target.value
                                                                    })}>
                                                                    <option value="">Select Cohort</option>
                                                                    {cohorts && cohorts.map((d, i) => <option
                                                                        key={i} value={d.id}>{d.title}</option>)}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <Label>Packages</Label>
                                                                <select className={'form-control'}
                                                                    onChange={e => setProgramMData({
                                                                        ...programMData,
                                                                        packageId: e.target.value
                                                                    })}>
                                                                    <option value="">Select Package</option>
                                                                    {packages && packages.map((d, i) => <option
                                                                        key={i} value={d.id}>{d.title}</option>)}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <Label>Level</Label>
                                                                <select className={'form-control'}
                                                                    onChange={e => setProgramMData({
                                                                        ...programMData,
                                                                        level: e.target.value
                                                                    })}>
                                                                    <option value="">Select Level</option>
                                                                    <option value="4">4</option>
                                                                    <option value="3">3</option>
                                                                    <option value="2">2</option>
                                                                    <option value="1">1</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <Label>Day</Label>
                                                                <select className={'form-control'}
                                                                    onChange={e => setProgramMData({
                                                                        ...programMData,
                                                                        day: e.target.value
                                                                    })}>
                                                                    <option value="">Select Day</option>
                                                                    {days.map((d, i) => <option
                                                                        key={i} value={i}>{d}</option>)}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <Label>Time</Label>
                                                                <select className={'form-control'}
                                                                    onChange={e => setProgramMData({
                                                                        ...programMData,
                                                                        time: e.target.value
                                                                    })}>
                                                                    <option value="">Select Time</option>
                                                                    {TIMES_.map((d, i) => <option
                                                                        key={i} value={i}>{d}</option>)}
                                                                </select>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div className="text-end">
                                                        <button
                                                            onClick={handleProgramClickSubmit}
                                                            className="btn btn-primary save-user">
                                                            Update Program Data
                                                        </button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                    </Modal>

                                    <Modal isOpen={scheduleConflictModal} toggle={() => { setScheduleConflictModal(false); setPendingTeacherPayload(null); }} centered>
                                        <ModalHeader toggle={() => { setScheduleConflictModal(false); setPendingTeacherPayload(null); }}>
                                            Schedule conflict warning
                                        </ModalHeader>
                                        <ModalBody>
                                            <p className="text-muted">
                                                This teacher is already assigned to another program at the same day and time (WAT) on a Not started or Ongoing cohort, with a different package type. Same package at the same slot is treated as a group class. You can cancel or continue anyway.
                                            </p>
                                            <ul className="small mb-0">
                                                {scheduleConflicts.map((c, idx) => (
                                                    <li key={idx} className="mb-2">
                                                        <strong>{c.slotLabel || "Slot"}</strong>
                                                        {c.message ? <> — {c.message}</> : null}
                                                    </li>
                                                ))}
                                            </ul>
                                        </ModalBody>
                                        <ModalFooter>
                                            <button type="button" className="btn btn-light" onClick={() => { setScheduleConflictModal(false); setPendingTeacherPayload(null); }}>
                                                Cancel
                                            </button>
                                            <button type="button" className="btn btn-warning" onClick={confirmScheduleConflictAndAssign} disabled={loading}>
                                                {loading ? "…" : "Continue anyway"}
                                            </button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={assignModal} toggle={() => setAssignModal(!assignModal)}>
                                        <ModalHeader toggle={() => setAssignModal(!assignModal)}>Assign
                                            Teacher</ModalHeader>
                                        <ModalBody>
                                            <Form onSubmit={(e) => {
                                                e.preventDefault();
                                                handleTeacherAssignClick().then(r => null);
                                            }}>
                                                <Row>
                                                    <Col xs={12}>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="mb-6">
                                                                    <Input
                                                                        name="teacherId"
                                                                        type="select"
                                                                        onChange={handleTeacherChange}>
                                                                        <option value="">Select teacher</option>
                                                                        {assignableTeachers?.length > 0 &&
                                                                            assignableTeachers?.map((teacher) => (
                                                                                <option key={teacher?.id}
                                                                                    value={teacher?.id}>
                                                                                    {teacher.firstName} {teacher.lastName}
                                                                                </option>
                                                                            ))}
                                                                    </Input>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <br />
                                                        <div className="text-end">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary save-user">
                                                                {loading ? "Processing" : " Assign New Teacher"}
                                                            </button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </ModalBody>
                                    </Modal>

                                    <Modal isOpen={assignActionModal}
                                        toggle={() => setAssignActionModal(!assignActionModal)}>
                                        <ModalHeader toggle={() => setAssignActionModal(!assignActionModal)}>
                                            Perform Group Teacher Assignment</ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <small className={'text-danger mb-3'}>Warning: This action will
                                                    alter {multiIDs.length} children. confirm again !</small>
                                                <Col xs={12}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="mb-6">
                                                                <select
                                                                    className={'form-control'}
                                                                    onChange={e => setMultiTargetIDs({
                                                                        ...multiTargetIDs,
                                                                        cohortId: e.target.value
                                                                    })}>
                                                                    <option value="">Select Cohort</option>
                                                                    {Array.isArray(cohorts) && cohorts.length > 0 &&
                                                                        cohorts.map((c, i) => (
                                                                            <option key={i}
                                                                                value={c.id}>
                                                                                {c.title}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-6">
                                                                <select
                                                                    className={'form-control'}
                                                                    onChange={e => setMultiTargetIDs({
                                                                        ...multiTargetIDs,
                                                                        teacherId: e.target.value
                                                                    })}>
                                                                    <option value="">Select Teacher</option>
                                                                    {assignableTeachers?.length > 0 &&
                                                                        assignableTeachers?.map((teacher) => (
                                                                            <option key={teacher?.id}
                                                                                value={teacher?.id}>
                                                                                {teacher.firstName} {teacher.lastName}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <br />
                                                    <div className="text-end">
                                                        <button
                                                            onClick={processBatchOperations}
                                                            type="submit"
                                                            className="btn btn-primary save-user">
                                                            Process Batch Data
                                                        </button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                    </Modal>
                                    <Modal isOpen={assignModal2} toggle={toggleAssignModal}>
                                        <ModalHeader toggle={toggleAssignModal}>
                                            {!selectedProgram ? `Assign ${multiIDs.length} Programs` : `Assign ${selectedProgram?.child?.parent?.firstName} ${selectedProgram?.child?.parent?.lastName}`}
                                        </ModalHeader>
                                        <ModalBody>
                                            <div className="mb-3">
                                                <Label className="form-label">Select Admin</Label>
                                                <select
                                                    className="form-control filter-control"
                                                    onChange={(e) => {
                                                        const adminId = e.target.value;
                                                        setSelectedAdmin(adminId);
                                                        console.log(adminId)
                                                    }}
                                                >
                                                    <option value="">Select an admin</option>
                                                    {admins.map(admin => (
                                                        <option key={admin.id} value={admin.id}>
                                                            {admin.fullName}
                                                        </option>
                                                    ))}
                                                </select>

                                                <div className={'align-middle my-3'}>
                                                    <input
                                                        style={{ marginRight: 5 }}
                                                        type={'checkbox'}
                                                        onChange={e => setSecondary(true)}
                                                    />
                                                    As Secondary
                                                </div>
                                            </div>
                                            <div className="text-end mt-4">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary me-2"
                                                    onClick={toggleAssignModal}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={handleAssignParent}
                                                    disabled={!selectedAdmin}
                                                >
                                                    Assign
                                                </button>
                                            </div>
                                        </ModalBody>
                                    </Modal>
                                    <Modal isOpen={noteModal} toggle={toggleNoteModal} size="l">
                                        <ModalHeader toggle={toggleNoteModal}>
                                            {!selectedProgram ? `Set alert for ${multiIDs.length} Programs` : `Set alert for ${selectedProgram?.child?.parent?.firstName} ${selectedProgram?.child?.parent?.lastName}`}
                                        </ModalHeader>
                                        <ModalBody>
                                            <div className="notes-container">
                                                {selectedProgram?.alertNote ? (
                                                    <div className="notes-list mb-4">
                                                        <div className="note-card mb-3 p-3">
                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                <div className="note-admin">
                                                                    <i className="mdi mdi-account-circle me-2"></i>
                                                                    ADMIN
                                                                </div>
                                                                <div className="note-date text-muted">
                                                                    {newFormatDate(selectedProgram?.alertDate)}
                                                                </div>
                                                            </div>
                                                            <div className="note-content p-2">
                                                                {selectedProgram?.alertNote}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    // <div className="add-note-section">
                                                    <EditorProvider>
                                                        <Editor
                                                            value={newNote}
                                                            onChange={(e) => setNewNote(e.target.value)}
                                                            containerProps={{ style: { resize: 'vertical', height: 150 } }}
                                                        >
                                                            <Toolbar>
                                                                <BtnBold />
                                                                <BtnItalic />
                                                                <BtnLink />
                                                                <BtnBulletList />
                                                                <BtnClearFormatting />
                                                                <BtnNumberedList />
                                                                <BtnUndo />
                                                                <BtnRedo />
                                                            </Toolbar>
                                                        </Editor>
                                                    </EditorProvider>
                                                    // </div>
                                                )}
                                                <div className="text-end mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary me-2"
                                                        onClick={() => {
                                                            setNewNote("");
                                                            toggleNoteModal();
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                    {!selectedProgram?.alertNote ?
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={handleAlert}
                                                        >
                                                            Set Alert
                                                        </button> :
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={handleAlertDone}
                                                        >
                                                            Done
                                                        </button>}
                                                </div>
                                            </div>
                                        </ModalBody>
                                    </Modal>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withAuth(ManageProgram);
